<ng-container *ngIf="name">
  <mat-icon *ngIf="isSvg; else materialIcon" [svgIcon]="name"></mat-icon>

  <ng-template #materialIcon>
    <mat-icon>{{ name }}</mat-icon>
  </ng-template>
</ng-container>
